import { render, staticRenderFns } from "./ParkingStatusLabel.vue?vue&type=template&id=3135df96&"
import script from "./ParkingStatusLabel.vue?vue&type=script&lang=js&"
export * from "./ParkingStatusLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports